import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { pdfStylesV2, divisorV2, PDF_COLORS, PDF_PAGE_MARGINS, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFItemsTableV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFKioskoQRV2, PDFBrandFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { PDFEquipoMedicoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFEquipoMedico";
import { PDFPagareV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPagare";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const ventaProgramadaPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const dataSat = values.respuestaFactura.dataSat;
  const idKiosko = values.kioskoid;

  // --- Equipo médico (misma condición que el clásico) ---
  const agregarEquipoMedico = PDFEquipoMedicoV2({ values, empresa });

  // --- Concurrencia (mismo cálculo que el clásico) ---
  let concurrencia;
  if (dataSat.Concurrencia === 1) {
    concurrencia = "Diario";
  } else if (dataSat.Concurrencia === 2) {
    concurrencia = "Semanal";
  } else if (dataSat.Concurrencia === 3) {
    concurrencia = "Quincenal";
  } else if (dataSat.Concurrencia === 4) {
    concurrencia = "Mensual";
  } else if (dataSat.Concurrencia === 5) {
    concurrencia = "Anual";
  }

  // --- Conceptos (mismo cálculo que el clásico; SIEMPRE IVA e IEPS) ---
  const conceptos = dataSat.Conceptos.map((valueConcepto) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });
    return [
      { style: "textoTablaChico", text: valueConcepto.Cantidad, alignment: "right" },
      { text: valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
      { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
      {
        text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      { text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "right" },
      { text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "right" },
      { text: dineroDisabledMask(valueConcepto.ValorUnitario), style: "textoTablaChico", alignment: "right" },
      { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "right" },
    ];
  });

  const title = [
    { text: "Cantidad", style: "tituloTabla" },
    { text: "Unidad", style: "tituloTabla" },
    { text: "Clave SAT", style: "tituloTabla" },
    { text: "Descripción", style: "tituloTabla" },
    { text: "IVA", style: "tituloTabla" },
    { text: "IEPS", style: "tituloTabla" },
    { text: "P/U", style: "tituloTabla" },
    { text: "Importe", style: "tituloTabla" },
  ];

  const widths = ["8%", "6%", "9%", "31%", "8%", "8%", "12%", "18%"];

  // --- Impuestos (mismo cálculo que el clásico; salida {label,value}) ---
  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [
      ...dataSat.Impuestos.Traslados,
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || []),
    ];

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002" ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%` : a.Impuesto === "003" ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%` : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002" ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%` : b.Impuesto === "003" ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%` : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") {
      nombre = "IVA";
    } else if (valueImpuesto.Impuesto === "003") {
      nombre = "IEPS";
    } else {
      nombre = valueImpuesto["@ImpLocTrasladado"];
    }

    if (valueImpuesto.TipoFactor === "Tasa") {
      nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    } else if (valueImpuesto.TipoFactor === "Cuota") {
      nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    }

    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [
      ...dataSat.Impuestos.Retenciones,
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || []),
    ];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") {
      nombre = nombre + "ISR";
    } else if (valueRetencion.Impuesto === "002") {
      nombre = nombre + "IVA";
    } else {
      nombre = valueRetencion["@ImpLocRetenido"];
    }
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any?.find((item) => item["implocal:ImpuestosLocales"])?.["implocal:ImpuestosLocales"]?.["@TotaldeRetenciones"] || 0) || 0;

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  // --- Metadata del encabezado (derecha) ---
  const headerMeta = [
    { label: "N° Venta P.:", value: (dataSat.Serie ? dataSat.Serie : "VP") + " - " + dataSat.Folio },
    { label: "Moneda:", value: dataSat.Moneda },
    { label: "T.C.:", value: dineroDisabledMask(dataSat.TipoCambio) },
  ];

  // --- Datos cliente (izquierda) ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    { label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") },
    { label: "Lugar de expedición:", value: dataSat.LugarExpedicion },
    { label: "Forma de pago:", value: "(" + dataSat.formaDePago.c_FormaPago + ") " + dataSat.formaDePago.descripcion },
    { label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" },
  ];

  // --- Datos venta programada (derecha) ---
  const clienteRight = [
    { label: "Orden de compra:", value: dataSat.pedido },
    { label: "Condiciones de pago:", value: dataSat.condicion === 1 ? "Contado" : "Credito" },
    { label: "Concurrencia:", value: concurrencia },
    { label: "Fecha de inicio:", value: moment(dataSat.FechaInicio).locale("es").format("LL") },
    { label: "Fecha de fin:", value: dataSat.FechaFin ? moment(dataSat.FechaFin).locale("es").format("LL") : " - " },
    { label: "Correo Automatico:", value: dataSat.CorreoAutomatico ? "Si" : "No" },
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  const bancosRows = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };

  const cierreIzquierda = {
    stack: [
      importeLetra,
      PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: bancosRows }),
    ],
  };

  // --- Filas de totales (derecha) ---
  const totalsRows = [
    { label: "Subtotal:", value: dineroDisabledMask(dataSat.SubTotal) },
    { label: "Descuento:", value: dineroDisabledMask(dataSat.Descuento) },
    ...impuestosTotales,
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  // --- Pagaré ---
  let anadirPagare = [];
  if (values.imprimirPagare && values.textoPagare) {
    anadirPagare = PDFPagareV2({
      empresa,
      meta: [
        { label: "N° Factura:", value: (dataSat.Serie ? dataSat.Serie : "F") + " - " + dataSat.Folio },
        { label: "Moneda:", value: dataSat.Moneda },
        { label: "Tipo de Cambio:", value: dineroDisabledMask(dataSat.TipoCambio) },
      ],
      buenoPor: dineroDisabledMask(dataSat.Total),
      texto: values.textoPagare,
      pagareCorto: values.pagareCorto,
    });
  }

  const dd = {
    watermark: { text: "SIN VALIDEZ", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 },
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Venta Programada",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "VP") + " - " + dataSat.Folio,
        regimenFiscal: true,
        tipoComprobante: "ingreso",
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 6, 1),
      ...agregarEquipoMedico,
      PDFItemsTableV2({ title, conceptos, widths }),
      PDFSummarySectionV2({ left: cierreIzquierda, rows: totalsRows }),
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      PDFKioskoQRV2(idKiosko, "Escané para realizar su factura."),
      ...anadirPagare,
    ],
    footer: PDFBrandFooterV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  return dd;
};

export default ventaProgramadaPdfV2;
